<template>
    <div class="">
        <b-modal :model-value="modalModManual" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                {{ labels.title }} {{ infoContrato?.nro_contrato }} 
            </div>
            <div>
                <!-- <pre>{{ infoContrato }}</pre> -->
                <b-row class="text-center">
                    <b-col cols="4" lg="auto">
                        <b-button @click="detalleContrato" class="md-dense md-raised md-primary btn-info">{{ labels.detalle }}</b-button> 
                    </b-col>
                    <b-col cols="4">
                        <b-button @click="activosContrato" class="md-dense md-raised md-primary btn-info">{{ labels.activos }}</b-button> 
                    </b-col>
                    <b-col cols="4">
                        <b-button @click="centroCostoContrato" class="md-dense md-raised md-primary btn-info">{{ labels.centroCosto }}</b-button> 
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" v-if="showModiDetalle">
                        <ModificacionDetalle :dataContrato="infoContrato" @cierraModal="cierraModal"></ModificacionDetalle>
                    </b-col>
                    <b-col cols="12" v-if="showModiActivos">
                        <ModificacionActivos :numContrato="infoContrato.nro_contrato" @cierraModal="cierraModal"></ModificacionActivos> 
                    </b-col>
                    <b-col cols="12" v-if="showModiCentroCosto">
                        <ModificacionCentroCosto :numContrato="infoContrato.nro_contrato" @cierraModal="cierraModal"></ModificacionCentroCosto> 
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="9">
                        <!-- <b-button class="md-primary" @click="saveModManual">{{ labels.save }}</b-button> --> 
                    </b-col>
                    <b-col cols="3" class="d-flex justify-content-end">
                        <!-- <b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> --> 
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ModificacionDetalle from './ModificacionDetalle.vue' 
import ModificacionActivos from './ModificacionActivos.vue' 
import ModificacionCentroCosto from './ModificacionCentroCosto.vue' 
export default {
    name : 'ModificacionManual',
    props:['modalModManual','infoContrato'],
    components:{
        ModificacionDetalle,
        ModificacionActivos,
        ModificacionCentroCosto,
    },
    data : () => ({
        showModiDetalle : false,
        showModiActivos : false,
        showModiCentroCosto : false,
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Contrato Nro.', 
                    save : 'Guardar',
                    close : 'Cerrar',
                    detalle : 'Modificación Detalle',
                    activos : 'Modificación Activos',
                    centroCosto : 'Modificación Centros Costos',
                    cuotas : 'Cuotas',
                }
            }else{
                return {
                    title : 'Contract No.', 
                    save : 'Save',
                    close : 'Close',
                    detalle : 'Detail',
                    activos : 'Assets',
                    centroCosto : 'Modificación Centros Costos',
                    cuotas : 'Cuotas',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
            this.showModiDetalle = false 
            this.showModiActivos = false 
            this.showModiCentroCosto = false 
        },
        detalleContrato(){
            this.showModiDetalle = true 
            this.showModiActivos = false 
            this.showModiCentroCosto = false 
        },
        centroCostoContrato(){
            this.showModiDetalle = false 
            this.showModiActivos = false 
            this.showModiCentroCosto = true 
        },
        activosContrato(){
            this.showModiActivos = true 
            this.showModiDetalle = false 
            this.showModiCentroCosto = false 
        }
    }
}
</script>
<style lang="css">
  .b-table-cell-container { 
    padding: 15px !important;
  }
  .b-table-head-label { 
    padding-left: 30px !important;
  }
</style>
